export default __webpack_public_path__ + "static/section6_bg-6e7f4d4de82a124a06735c992620a226.png";